import { ThemeConfig } from 'core/theme/entities';

export enum ContentType {
  LOGO = 'logo',
}

export type Appearance = {
  themeConfig?: ThemeConfig;
  screensConfig: {
    header?: {
      exclude: string[];
      contentTypes: Record<ContentType, string[]>;
    };
    progressBar: {
      title?: string;
      amountOfSteps: number;
    }[];
  };
};
